<es-details-card
  *ngIf="shipment"
  [info]="info"
  [canEdit]="canEdit"
  [canDelete]="canEdit"
  [index]="isMultiBl ? index + 1 : null"
  (edit)="goToEdit()"
  (delete)="onDelete()"
>
  <div class="row card-bill-title" *ngIf="shipment.masterBill?.number || shipment.masterBill?.carrier">
    <div class="col-12">{{ currentLabelsData.titleMaster | translate }}</div>
  </div>
  <div class="row" *ngIf="shipment.masterBill?.carrier">
    <div class="col-6 card-label">{{ currentLabelsData.titleCarrier | translate }}</div>
    <div class="col-6">{{ shipment.masterBill?.carrier }}</div>
  </div>
  <div class="row" *ngIf="shipment.masterBill?.number">
    <div class="col-6 card-label">{{ currentLabelsData.titleNumber | translate }}</div>
    <div class="col-6">{{ shipment.masterBill?.number }}</div>
  </div>
  <div class="row" *ngIf="shipment.masterBill?.number || shipment.masterBill?.carrier"><div class="col-12 card-bill-border"></div></div>
  <div class="row card-bill-title" *ngIf="shipment.houseBill?.number || shipment.houseBill?.carrier">
    <div class="col-12">{{ currentLabelsData.titleHouse | translate }}</div>
  </div>
  <div class="row" *ngIf="shipment.houseBill?.carrier">
    <div class="col-6 card-label">{{ currentLabelsData.titleCarrier | translate }}</div>
    <div class="col-6">{{ shipment.houseBill?.carrier }}</div>
  </div>
  <div class="row" *ngIf="shipment.houseBill?.number">
    <div class="col-6 card-label">{{ currentLabelsData.titleNumber | translate }}</div>
    <div class="col-6">{{ shipment.houseBill?.number }}</div>
  </div>
  <div class="row" *ngIf="shipment.houseBill?.number || shipment.houseBill?.carrier"><div class="col-12 card-bill-border"></div></div>
  <ng-template [ngIf]="shipment.quantityUnit || shipment.quantity">
    <div class="row">
      <div class="col-6 card-label">{{ "FORM_LABEL.TOTAL_QUANTITY" | translate }}</div>
      <div class="col-6">{{ shipment.quantity ? shipment.quantity : "" }} {{ shipment.quantityUnit ? shipment.quantityUnit : "" }}</div>
    </div>
    <div class="row"><div class="col-12 card-bill-border"></div></div>
  </ng-template>
  <ng-template [ngIf]="connectedIsfs?.length">
    <div class="row">
      <div class="col-6 card-label">{{ "LABELS.CONNECTED_ISFS" | translate }}</div>
      <div class="col-6" fxLayout="column">
        <div class="connected-isfs" [class.connected-isfs--all]="!isShowMoreISFs" fxLayout="column">
          <ng-template ngFor [ngForOf]="connectedIsfs" let-isf>
            <a [routerLink]="['/isfs-management', isf.id]">{{ isf.name }}</a>
          </ng-template>
        </div>
        <ng-template [ngIf]="connectedIsfs.length > 3">
          <button type="button" class="btn btn-link btn-sm" fxFlexAlign="baseline" (click)="isShowMoreISFs = !isShowMoreISFs">
            {{ isShowMoreISFs ? ("BUTTON.SHOW_MORE" | translate) : ("BUTTON.SHOW_LESS" | translate) }}
          </button>
        </ng-template>
      </div>
    </div>
    <div class="row"><div class="col-12 card-bill-border"></div></div>
  </ng-template>
  <div class="row" *ngIf="hasSingleExportData && foreignPort && !isAir">
    <div class="col-6 card-label">{{ "FORM_LABEL.FOREIGN_PORT" | translate }}</div>
    <div class="col-6">{{ foreignPort.code }} {{ foreignPort.portName }} {{ foreignPort.countryCode }}</div>
  </div>
  <div class="row" *ngIf="hasSingleExportData && shipment.exportDate">
    <div class="col-6 card-label">{{ "FORM_LABEL.EXPORT_DATE" | translate }}</div>
    <div class="col-6">{{ shipment.exportDate | customDateByUtc }}</div>
  </div>
  <div class="row" *ngIf="shipment.itDate">
    <div class="col-6 card-label">{{ "FORM_LABEL.IT_DATE" | translate }}</div>
    <div class="col-6">{{ shipment.itDate | customDateByUtc }}</div>
  </div>
  <div class="row" *ngIf="shipment.itNumber">
    <div class="col-6 card-label">{{ "FORM_LABEL.IT_NUMBER" | translate }}</div>
    <div class="col-6">{{ shipment.itNumber }}</div>
  </div>
  <div class="row">
    <div class="col-6 card-label">{{ "FORM_LABEL.CHARGES_DISTRIBUTION_TYPE" | translate }}</div>
    <div class="col-6">
      {{ "CHARGES_DISTRIBUTION_TYPE." + enumChargesDistributionType[shipment.chargesDistributionType] | translate }}
    </div>
  </div>
  <div *ngIf="shipment.chargesDistributionType === enumChargesDistributionType.PREPAID" class="row">
    <div class="col-6 card-label">{{ "FORM_LABEL.INSURANCE" | translate }}</div>
    <div class="col-6">{{ shipment.insurance || 0 | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}</div>
  </div>
  <div *ngIf="shipment.chargesDistributionType === enumChargesDistributionType.PREPAID" class="row">
    <div class="col-6 card-label">{{ "FORM_LABEL.TRANSPORTATION" | translate }}</div>
    <div class="col-6">{{ shipment.transportationCharge || 0 | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}</div>
  </div>
  <div class="row">
    <div class="col-6 card-label">{{ "FORM_LABEL.FREIGHT_COST" | translate }}</div>
    <div class="col-6">{{ shipment.freightCost || 0 | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}</div>
  </div>
  <div class="error-message" *ngFor="let message of shipmentValidationMessages">{{ "BACK_ERROR." + message.text | translate }}</div>

  <es-details-subcard [title]="'INFO.CN.TITLE'" [isMissing]="isConsigneeMissed">
    <div action class="summary-card-edit" *ngIf="canEdit" (click)="goToEditConsignee()">
      <button class="btn btn-link">
        <i class="fa fa-pencil"></i>
      </button>
    </div>
    <ng-template [ngIf]="shipment.consignee">
      <div class="row" *ngIf="shipment.consignee.entityIdentifier">
        <div class="col-6 card-label">{{ "LABELS.ID_NUMBER" | translate }}</div>
        <div class="col-6">
          <ng-template [ngIf]="shipment?.consignee?.entityIdentifierQualifier">
            {{ ("IDENTIFIER_QUALIFIER." + shipment.consignee.entityIdentifierQualifier | translate) + " " }}
          </ng-template>
          {{ shipment.consignee.entityIdentifier | identifier }}
        </div>
      </div>
      <div class="row" *ngIf="shipment.consignee.name">
        <div class="col-6 card-label">{{ "LABELS.NAME" | translate }}</div>
        <div class="col-6">{{ shipment.consignee.name }}</div>
      </div>
      <div class="row" *ngIf="shipment.consignee.address">
        <div class="col-6 card-label">{{ "LABELS.ADDRESS" | translate }}</div>
        <div class="col-6">
          <address-details [address]="shipment.consignee.address"></address-details>
        </div>
      </div>
      <div class="error-message" *ngFor="let message of consigneeValidationMessages">{{ "BACK_ERROR." + message.text | translate }}</div>
    </ng-template>
  </es-details-subcard>
  <es-details-subcard [title]="'INFO.BY.TITLE'" [isMissing]="isBuyerMissed">
    <div action class="summary-card-edit" *ngIf="canEdit" (click)="goToEditBuyer()">
      <button class="btn btn-link">
        <i class="fa fa-pencil"></i>
      </button>
    </div>
    <ng-template [ngIf]="shipment.buyer">
      <div class="row" *ngIf="shipment.buyer.entityIdentifier">
        <div class="col-6 card-label">{{ "LABELS.ID_NUMBER" | translate }}</div>
        <div class="col-6">
          <ng-template [ngIf]="shipment?.buyer?.entityIdentifierQualifier">
            {{ ("IDENTIFIER_QUALIFIER." + shipment.buyer.entityIdentifierQualifier | translate) + " " }}
          </ng-template>
          {{ shipment.buyer.entityIdentifier | identifier }}
        </div>
      </div>
      <div class="row" *ngIf="shipment.buyer.name">
        <div class="col-6 card-label">{{ "LABELS.NAME" | translate }}</div>
        <div class="col-6">{{ shipment.buyer.name }}</div>
      </div>
      <div class="row" *ngIf="shipment.buyer.address">
        <div class="col-6 card-label">{{ "LABELS.ADDRESS" | translate }}</div>
        <div class="col-6">
          <address-details [address]="shipment.buyer.address"></address-details>
        </div>
      </div>
      <div class="error-message" *ngFor="let message of buyerValidationMessages">{{ "BACK_ERROR." + message.text | translate }}</div>
    </ng-template>
  </es-details-subcard>
  <es-details-subcard [title]="'INFO.SP.TITLE'" [isMissing]="isSellerMissed">
    <div action class="summary-card-edit" *ngIf="canEdit" (click)="goToEditSupplier()">
      <button class="btn btn-link">
        <i class="fa fa-pencil"></i>
      </button>
    </div>
    <ng-template [ngIf]="shipment.seller">
      <div class="row" *ngIf="shipment.seller.name">
        <div class="col-6 card-label">{{ "LABELS.NAME" | translate }}</div>
        <div class="col-6">{{ shipment.seller.name }}</div>
      </div>
      <div class="row" *ngIf="shipment.seller.address">
        <div class="col-6 card-label">{{ "LABELS.ADDRESS" | translate }}</div>
        <div class="col-6">
          <address-details [address]="shipment.seller.address"></address-details>
        </div>
      </div>
      <div class="error-message" *ngFor="let message of sellerValidationMessages">{{ "BACK_ERROR." + message.text | translate }}</div>
    </ng-template>
  </es-details-subcard>
  <es-details-invoice-card
    *ngFor="let invoice of shipment.invoices; let index = index"
    [transportationMode]="transportationMode"
    [canEdit]="canEdit"
    [invoice]="invoice"
    [index]="isMultiInvoice ? index + 1 : null"
    [allValidationMessages]="allValidationMessages"
    [isRequiredDocument]="isRequiredDocument"
    (editInvoice)="goToEditInvoice($event)"
    (removeInvoice)="onDeleteInvoice($event)"
  ></es-details-invoice-card>

  <div class="summary-subcard-footer">
    <div class="row" *ngIf="shipment.invoices">
      <div class="col-6">
        <h6>{{ "DASHBOARD_TITLE.INVOICES" | translate }}:</h6>
        <h5 class="mb-0">{{ shipment.invoices.length }}</h5>
      </div>
      <div class="col-6">
        <h6>{{ "ENTRY_SUMMARY.BL_ENTERED_VALUE" | translate }}:</h6>
        <h5 class="mb-0 text-result">{{ blEnteredValue | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}</h5>
      </div>
      <ng-template [ngIf]="isOpenInvoicesOnEdit">
        <icon-toggle-open-close class="open-close-icon" (click)="goToEditInvoices()" [open]="isOpenInvoices"></icon-toggle-open-close>
      </ng-template>
      <ng-template [ngIf]="!isOpenInvoicesOnEdit">
        <img
          alt="right"
          class="icon-next"
          [ngClass]="{ open: isOpenInvoices }"
          (click)="goToEditInvoices()"
          src="/assets/icons/chevron_right.svg"
        />
      </ng-template>
    </div>
  </div>
</es-details-card>

<ng-template [ngIf]="isOpenInvoices">
  <es-invoice-summary-details
    *ngFor="let invoice of shipment.invoices; let index = index"
    [transportationMode]="transportationMode"
    [invoice]="invoice"
    [currencyRate]="ratesMap.has(invoice.currency) ? ratesMap.get(invoice.currency).rate : 1"
    [incoterms]="incoterms"
    [index]="isMultiInvoice ? index + 1 : null"
    [isCanEdit]="canEdit"
    [isCanView]="canEdit"
  ></es-invoice-summary-details>
</ng-template>
